import 'vite/modulepreload-polyfill'
import Alpine from 'alpinejs'

import TieredDiscountsWidget from '@scripts/components/tiered-discounts-widget'
import { tieredDiscountsStore } from '@scripts/utils/tiered-discounts-store'

window.Alpine = Alpine

document.addEventListener('alpine:init', () => {
  // Register Alpine store
  Alpine.store('tieredDiscounts', tieredDiscountsStore())

  // Register components
  Alpine.data('tieredDiscounts', TieredDiscountsWidget)
})

Alpine.start()
